import { render, staticRenderFns } from "./UserData.vue?vue&type=template&id=14a0cde0&scoped=true&"
import script from "./UserData.vue?vue&type=script&lang=js&"
export * from "./UserData.vue?vue&type=script&lang=js&"
import style0 from "./UserData.vue?vue&type=style&index=0&id=14a0cde0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a0cde0",
  null
  
)

export default component.exports